<div class="kt-portlet">
	<div class="kt-portlet__head kt-portlet__head__custom">
			<div class="kt-portlet__head-progress">
					<mat-progress-bar mode="indeterminate" *ngIf="ShowSpinner"></mat-progress-bar>
			</div>
		<div class="kt-portlet__head-label">
			<h3 class="kt-portlet__head-title">{{ data.dialogHeader }}</h3>
		</div>
	</div>
	<form class="kt-form" >
		<div class="kt-portlet__body">
		<div class="row">
			<div class="col">
				<div class="col-lg-12 kt-margin-bottom-20-mobile m-3">
                    {{ data.dialogDescription }}
				</div>
			</div>
		</div>

		</div>
		<div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit">
			<div class="kt-form__actions kt-form__actions--solid">
				<div class="row text-right">
					<div class="col-lg-12">
						<button type="button" mat-raised-button [mat-dialog-close]=" " [disabled]="ShowSpinner" cdkFocusInitial matTooltip="Cancel changes">
							Cancel
						</button>&nbsp;
						<button class="btn btn-primary" type="button" mat-raised-button color="warn" (click)="onSubmit()" [disabled]="ShowSpinner">
							Confirm
						</button>
					</div>
				</div>
			</div>
		</div>
	</form>
</div>
